import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Toaster.scss';
import Danger from './Danger.svg';
import Success from './Success.svg';
import Warning from './Warning.svg';

export default class Toaster extends Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    level: PropTypes.string,
    visible: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    level: 'warning',
  };

  // constructor(props) {
  //   super(props);
  //   // this.state = {
  //   //   visible: false,
  //   // };
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.visible !== nextProps.visible) {
  //     this.setState({
  //       visible: nextProps.visible,
  //     });
  //   }
  // }

  _getIcon() {
    switch (this.props.level) {
      case 'warning':
        return Warning;
      case 'danger':
        return Danger;
      case 'success':
        return Success;
      default:
        return '';
    }
  }

  render() {
    let classes = `toast ${this.props.level} `;
    classes += this.props.visible ? 'visible' : '';
    return (
      <div className={classes}>
        <figure>
          <img src={this._getIcon()} alt={this.props.level} />
        </figure>
        <p>{this.props.message}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Toaster/Toaster.jsx